<div style="max-height: 200px;
overflow: auto;
padding-right: 1rem;">
<form [formGroup]='formGroup' class='filters' (ngSubmit)='accept()'>
  <div *ngFor='let element of selectedFilters; let last = last'>
    <div fxLayout='row' fxLayoutGap="0.5rem" fxLayout.lt-md="column">
      <div fxFlex='20' fxFlex.lt-md='20'>
        <mat-form-field class='field-filter' appearance='outline' class="full-width">
          <mat-label>Type</mat-label>
          <input matInput name="type" disabled [value]='element.name'/>
        </mat-form-field>
      </div>
      <div fxFlex='40' fxFlex.lt-md='50'>
        <ng-container *ngIf='element.type === "text"'>
          <text [data]='element'></text>
        </ng-container>
        <ng-container *ngIf='element.type === "number"'>
          <number [data]='element'></number>
        </ng-container>
        <ng-container *ngIf='element.type === "number_range"'>
          <number-range [data]='element'></number-range>
        </ng-container>
        <ng-container *ngIf='element.type === "date"'>
          <date [data]='element'></date>
        </ng-container>
        <ng-container *ngIf='element.type === "date_range"'>
          <date-range  [data]='element'></date-range>
        </ng-container>
        <ng-container *ngIf='element.type === "select"'>
          <select-filter [data]='element'></select-filter>
        </ng-container>
      </div>
      <div fxFlex fxLayoutAlign='end start' fxLayoutGap="0.5rem">
        <button mat-icon-button matSuffix color='primary' (click)='deleteFilter(element.name)' class='remove-btm'>
          <mat-icon>close</mat-icon>
        </button>
        <button type="button" *ngIf="last" mat-icon-button matSuffix color='primary' (click)='filterSelected = null'
            class='add-btm'>
      <mat-icon>add</mat-icon>
    </button>
      </div>
    </div>
  </div>
</form>

<div fxLayout='row' fxLayout.lt-md="column">
  <div fxFlex='20' fxFlex.lt-md='20' *ngIf="!filterSelected || selectedFilters.length === 0">
    <ng-select class='field-filter' [closeOnSelect]='true' [clearable]='true' [clearSearchOnAdd]='true'
    appearance='outline'
    appendTo="body"
               placeholder='Select Filter' [(ngModel)]='filterSelected' (change)="addFilter()">
      <ng-option *ngFor='let item of filtersList' [value]='item.name'>{{item.name}}</ng-option>
    </ng-select>
  </div>
  <!-- <div fxFlex='60' fxLayoutAlign='end center' fxFlex.lt-md='20'>
    <button fxFlexAlign='center' *ngIf='filterSelected' mat-icon-button matSuffix color='primary' (click)='addFilter()'
            class='add-btm'>
      <mat-icon>add</mat-icon>
    </button>
  </div> -->
</div>

<div fxLayout fxLayoutAlign='end center' style="margin-top: 8px;">
  <div>
    <button mat-raised-button color='primary' (click)='accept()' type='submit' class='button' style='width: 95%'>
      Search
    </button>
  </div>
  <div>
    <button mat-raised-button color='secondery' (click)='formGroup.reset()' class='button'>
      Clear
    </button>
  </div>
</div>
<br>
</div>


